import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { createDocType, updateDocType } from "@/api/customerCenter/customerCenter";
export default {
  name: "addTypeItem",
  data: function data() {
    var validateDocType = function validateDocType(rule, value, callback) {
      if (!value) {
        callback(new Error('请输入文档类型'));
      } else if (!/^[a-z0-9_-]+$/.test(value)) {
        callback(new Error('文档类型只能包含小写字母、数字、下划线和短横线'));
      } else {
        callback();
      }
    };

    return {
      dialog: false,
      pramsData: {
        doc_type: '',
        name: '',
        pay_channel: '',
        description: '',
        enabled: true
      },
      rules: {
        doc_type: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }, {
          validator: validateDocType,
          trigger: "blur"
        }],
        name: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        description: [{
          required: true,
          message: "请输人",
          trigger: "blur"
        }],
        enabled: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    open: function open(data) {
      if (data) {
        this.pramsData = _objectSpread({}, data);
        this.pramsData.old_doc_type = data.doc_type;
      }

      this.dialog = true;
    },
    resetForm: function resetForm() {
      this.dialog = false;
      this.clearData();
    },
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var data = JSON.parse(JSON.stringify(_this.pramsData));
          var reqFn = _this.pramsData.old_doc_type ? updateDocType : createDocType;
          reqFn(_objectSpread({}, data)).then(function (res) {
            if (res.status == 'succeeded') {
              _this.resetForm();

              _this.$message({
                message: '操作成功',
                type: 'success'
              });

              _this.$emit('change');
            }
          });
        }
      });
    },
    clearData: function clearData() {
      this.pramsData = {
        doc_type: '',
        name: '',
        pay_channel: '',
        description: '',
        enabled: true
      };
      this.$refs.ruleForm.resetFields();
    }
  }
};